import { Component, Inject, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { environment } from 'environments/environment';
import { Observable, map } from 'rxjs';
import { LenderUser } from './models/dto/lender-user.model';
import { PusherService } from './modules/shared/services/pusher.service';
import { RollbarService } from './rollbar';
import { GetLenderUser } from './store/lender-user/lender-user/lender-user.actions';
import { LenderUserState } from './store/lender-user/lender-user/lender-user.state';
import { Router, NavigationStart } from '@angular/router';
import { AuthenticationService } from './modules/session/services/authentication.service';
import { isMobileDevice } from 'app/util/mobile/isMobile';
import { isChromeBrowser } from 'app/util/browser/chrome';

import Rollbar from 'rollbar';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;

  canSubmitCxInteractions$: Observable<boolean>;
  title = 'pipeline';
  siteIsUpdated = false;
  globalHeaderLoaded = false;
  loginPage = false;
  isSupported: boolean;
  canViewCxInteractions: boolean = false;

  constructor(
    @Inject(RollbarService) private rollbar: Rollbar,
    private store: Store,
    private pusherService: PusherService,
    private auth: AuthenticationService,
    router: Router
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationStart && this.siteIsUpdated && !this.callInProgress()) {
        this.siteIsUpdated = false;
        location.reload();
      }
    });
  }

  ngOnInit() {
    if (this.auth.isAuthenticated()) {
      this.store.dispatch(new GetLenderUser());
      this.subscribeToGlobalChannel();

      this.canSubmitCxInteractions$ = this.lenderUser$.pipe(
        map(currentUser => {
          return !!currentUser ? (
            currentUser.team?.type?.includes('customer_service')
            || currentUser.team?.name?.includes('Test'))
            : false;
        })
      );
      this.canSubmitCxInteractions$.subscribe(result => {this.canViewCxInteractions = result;});
    } else {
      this.loginPage = true;
    }

    const isChrome = isChromeBrowser();
    const isMobile = isMobileDevice();
    this.isSupported = isChrome && !isMobile;
  }

  rollbarInfo() {
    // Needs the rollbar object from the constructor.
    this.rollbar.info('dat new pipeline test log');
  }

  throwError() {
    // and will still log to Rollbar.
    throw new Error('dat new pipeline test error');
  }

  subscribeToGlobalChannel() {
    this.pusherService
      .subscribeRaw(`LS-global-${environment.environment}-channel`)
      .bind('siteUpdate', () => this.siteIsUpdated = true);
  }

  callInProgress() {
    return JSON.parse(localStorage.getItem('currentCall') || '{}')?.callId ? true : false;
  };

  headerLoaded() {
    setTimeout(() => this.globalHeaderLoaded = true, 0);
  }
}
